import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mode-group-avatar',
  templateUrl: './group-avatar.component.html',
  styleUrls: ['./group-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupAvatarComponent {}
